import { Button, ButtonGroup, Grid, withStyles, Theme } from '@material-ui/core'
import { TFunction } from 'i18next'
import { FC } from 'react'
import { UpdateStatus, UpdateStatusWithForm } from '../../actions/types'
import UpdateStatusFormProps from '../../containers/Apartments/AdminView/updateStatusForm'
import Dialog from '../../containers/Dialog'
import {
  isApartmentMarketingDisabled,
  isApartmentRentedDisabled,
  isApartmentCancelledDisabled
} from '../../libs/statuses'
import { MuiClasses } from '../../types'
import { ApartmentStatus, Status } from '../../types/apartments'
import { Message } from '../Messages'

const styles = ({ breakpoints, spacing }: Theme) => ({
  primaryBtn: {
    backgroundColor: '#94004A',
    '&:hover': {
      backgroundColor: '#670033'
    }
  }
})
interface UpdateStatusButtonProps {
  classes: MuiClasses
  currentStatus: Status
  updateStatus: UpdateStatus
  t: TFunction
  updateStatusWithForm: UpdateStatusWithForm
  selectedContractWantedName: string | undefined
  address: string | undefined
}

const UpdateStatusButtons: FC<UpdateStatusButtonProps> = ({
  classes,
  currentStatus,
  updateStatus,
  updateStatusWithForm,
  selectedContractWantedName,
  t,
  address
}) => {
  const commonButtonProps = {
    size: 'small' as const
  }

  const rentContractTitle =
    currentStatus === 'rentContractWanted'
      ? t('adminApartments.actions.updateApplicationId')
      : t('adminApartments.changeStatus.toRentContractWanted')

  return (
    <Grid container>
      <ButtonGroup
        variant='contained'
        color='primary'
        aria-label='contained primary button group'
      >
        <Button
          className={classes.primaryBtn}
          {...commonButtonProps}
          disabled={isApartmentMarketingDisabled(currentStatus)}
          onClick={() => updateStatus(ApartmentStatus.marketing)}
        >
          {t('adminApartments.changeStatus.toMarketing')}
        </Button>
        <Dialog
          dialogId='UpdateApartmentStatus'
          title={rentContractTitle}
          buttonLabel={rentContractTitle}
          buttonClassName={classes.primaryBtn}
          Content={
            <UpdateStatusFormProps
              t={t}
              updateStatusWithForm={updateStatusWithForm}
              initialValues={{
                status: ApartmentStatus.rentContractWanted
              }}
            />
          }
        />
        <Dialog
          dialogId='UpdateStatusToRented'
          disabled={isApartmentRentedDisabled(
            currentStatus,
            selectedContractWantedName
          )}
          title={t('apartments.rented.label')}
          buttonLabel={t('adminApartments.changeStatus.toRented')}
          confirmDialogSubmitAction={() => updateStatus(ApartmentStatus.rented)}
          Content={
            <Message
              message={t('apartments.rented.confirmMessage', {
                applicantName:
                  selectedContractWantedName ||
                  t('application.noApplicationFound')
              })}
            />
          }
        />
      </ButtonGroup>
      <Grid item style={{ marginLeft: 'auto' }}>
        <Dialog
          dialogId='UpdateStatusToCancelled'
          disabled={isApartmentCancelledDisabled(currentStatus)}
          color='secondary'
          title={t('apartments.cancel.label')}
          buttonLabel={t('adminApartments.changeStatus.toCancelled')}
          confirmDialogSubmitAction={() =>
            updateStatus(ApartmentStatus.cancelled)
          }
          Content={
            <Message
              message={t('apartments.cancel.confirmMessage', {
                address: address || ''
              })}
            />
          }
        />
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(UpdateStatusButtons)
